import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from './firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';

export default function BottomNav() {
  const navigate = useNavigate();

  const [hasActiveBooking, setHasActiveBooking] = useState(
    !!localStorage.getItem('fivetryActiveBooking')
  );
  const [itemCount, setItemCount] = useState(() => {
    try {
      const data = localStorage.getItem('fivetryActiveBookingData');
      if (data) {
        const parsed = JSON.parse(data);
        return parsed.itemsSelected || 0;
      }
    } catch (e) {}
    return 0;
  });

  // Listen for booking changes via custom event
  useEffect(() => {
    const handler = () => {
      setHasActiveBooking(!!localStorage.getItem('fivetryActiveBooking'));
      try {
        const data = localStorage.getItem('fivetryActiveBookingData');
        if (data) {
          const parsed = JSON.parse(data);
          setItemCount(parsed.itemsSelected || 0);
        } else {
          setItemCount(0);
        }
      } catch (e) {
        setItemCount(0);
      }
    };
    window.addEventListener('fivetryBookingChange', handler);
    return () => window.removeEventListener('fivetryBookingChange', handler);
  }, []);

  // AUTO-CLEAR: Check Firestore for completion status
  useEffect(() => {
    const checkActiveBookingStatus = async () => {
      const data = localStorage.getItem('fivetryActiveBookingData');
      if (!data) return;
      try {
        const booking = JSON.parse(data);
        if (!booking.bookingId) return;
        const q = query(
          collection(db, 'bookings'),
          where('bookingId', '==', booking.bookingId)
        );
        const snapshot = await getDocs(q);
        snapshot.forEach(docSnap => {
          const bookingData = docSnap.data();
          if (bookingData.orderStatus === 'completed') {
            localStorage.removeItem('fivetryActiveBooking');
            localStorage.removeItem('fivetryActiveBookingData');
            localStorage.removeItem('fivetryTrialDecisions');
            setHasActiveBooking(false);
            setItemCount(0);
            window.dispatchEvent(new Event('fivetryBookingChange'));
          }
        });
      } catch (e) {
        console.error('Error checking booking status:', e);
      }
    };

    // Check on mount
    checkActiveBookingStatus();

    // Also check when user returns to this tab
    const handleVisibilityChange = () => {
      if (!document.hidden) checkActiveBookingStatus();
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  const darkColor = '#1a1a1a';
  const greenColor = '#16a34a';
  const trialColor = hasActiveBooking ? greenColor : darkColor;

  const tabStyle = {
    flex: 1,
    padding: '10px 8px 14px',
    textAlign: 'center',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    transition: 'color 0.2s',
  };

  const smallLabel = {
    fontSize: '8px',
    letterSpacing: '1.5px',
    fontWeight: '500',
    marginTop: '4px',
    lineHeight: '1.1',
  };

  const mainLabel = {
    fontSize: '10px',
    letterSpacing: '1.5px',
    fontWeight: '600',
    lineHeight: '1.1',
  };

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: 'white',
      borderTop: '1px solid #eeeae3',
      display: 'flex',
      zIndex: 1500,
      boxShadow: '0 -2px 8px rgba(0,0,0,0.04)',
    }}>

      {/* SWEET HOME */}
      <div onClick={() => navigate('/')} style={{ ...tabStyle, color: darkColor }}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 9 L12 3 L21 9 V20 a1 1 0 0 1 -1 1 H4 a1 1 0 0 1 -1 -1 Z" />
          <path d="M9 21 V13 H15 V21" />
        </svg>
        <div style={smallLabel}>SWEET</div>
        <div style={mainLabel}>HOME</div>
      </div>

      {/* MY ORDERS */}
      <div onClick={() => navigate('/my-orders')} style={{ ...tabStyle, color: darkColor }}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <rect x="5" y="3" width="14" height="18" rx="2" />
          <line x1="9" y1="8" x2="15" y2="8" />
          <line x1="9" y1="12" x2="15" y2="12" />
          <line x1="9" y1="16" x2="13" y2="16" />
        </svg>
        <div style={smallLabel}>MY</div>
        <div style={mainLabel}>ORDERS</div>
      </div>

      {/* MY TRIAL BAG */}
      <div onClick={() => navigate('/my-trial')} style={{ ...tabStyle, color: trialColor }}>
        <span style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M6 2 L3 6 V20 a2 2 0 0 0 2 2 H19 a2 2 0 0 0 2-2 V6 L18 2 Z" />
            <line x1="3" y1="6" x2="21" y2="6" />
            <path d="M16 10 a4 4 0 0 1 -8 0" />
          </svg>
          {hasActiveBooking && itemCount > 0 && (
            <span style={{
              position: 'absolute',
              top: '-6px',
              right: '-8px',
              background: greenColor,
              color: 'white',
              borderRadius: '50%',
              width: '16px',
              height: '16px',
              fontSize: '9px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: '700',
            }}>{itemCount}</span>
          )}
        </span>
        <div style={smallLabel}>MY</div>
        <div style={mainLabel}>TRIAL BAG</div>
      </div>

    </div>
  );
}